import SelectV2 from './SelectV2.component';

export default SelectV2;
